import { Flame } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function RevealedPanel({ plaintext, oneTime }) {
  const { t } = useLang();
  return (
    <div className="border border-[#00ff66]/40 bg-white dark:bg-black" data-testid="revealed-panel">
      <div className="border-b border-[#00ff66]/30 px-6 py-3 flex items-center justify-between">
        <span className="text-xs font-mono uppercase tracking-widest text-[#00ff66]">
          decrypted
        </span>
        <span className="text-[10px] font-mono uppercase tracking-widest text-neutral-500">
          {plaintext.length} {t("charCount")}
        </span>
      </div>
      <pre
        data-testid="plaintext-output"
        className="p-6 md:p-8 font-mono text-sm md:text-base text-neutral-900 dark:text-neutral-100 whitespace-pre-wrap break-words leading-relaxed"
      >
        {plaintext}
      </pre>
      {oneTime && (
        <div className="border-t border-[#ff3b30]/30 px-6 py-3 text-[10px] font-mono uppercase tracking-widest text-[#ff3b30]">
          <Flame className="w-3 h-3 inline mr-2" />
          {t("burned")}
        </div>
      )}
    </div>
  );
}
